var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('b-modal', {
    attrs: {
      "dialog-class": "modal-end mx-lg-auto",
      "id": "modal-end",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('h5', {
    staticClass: "modal-title text-center"
  }, [_vm._v(_vm._s(_vm.event.config.end_title))]), _c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.event.config.end_content)
    }
  })]), _c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/newyear_header.jpg")
    }
  }), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/newyear_gift.jpg")
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "pb-5"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/newyear_title1.png")
    }
  }), _vm.user ? _c('div', {
    staticClass: "d-flex justify-content-center p-3 text-large"
  }, [_c('div', [_c('div', {
    staticClass: "text-white"
  }, [_c('span', {
    staticClass: "text-highlight mr-2"
  }, [_vm._v("會員姓名")]), _vm._v(_vm._s(_vm.user.name) + " ")]), _c('div', {
    staticClass: "text-white"
  }, [_c('span', {
    staticClass: "text-highlight mr-2"
  }, [_vm._v("手機號碼")]), _vm._v(_vm._s(_vm.user.mobile_phone) + " ")])])]) : _vm._e()]), _c('div', {
    staticClass: "pb-5"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/newyear_title2.png")
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "w-75 p-3"
  }, [_vm._l(5, function (i) {
    return _c('b-form-input', {
      key: i,
      staticClass: "field__input bg-white mb-2 text-uppercase",
      class: _vm.isExpired && 'input-disabled',
      attrs: {
        "placeholder": _vm.event.config.input_tip_msg,
        "state": _vm.isFailedRedeem(_vm.redeem_codes[i - 1]),
        "formatter": _vm.formatter,
        "disabled": _vm.isExpired
      },
      model: {
        value: _vm.redeem_codes[i - 1],
        callback: function callback($$v) {
          _vm.$set(_vm.redeem_codes, i - 1, $$v);
        },
        expression: "redeem_codes[i - 1]"
      }
    });
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [false ? _c('label', {
    staticClass: "agree mt-4 d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkItem,
      expression: "checkItem"
    }],
    staticClass: "border-0 mr-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkItem) ? _vm._i(_vm.checkItem, null) > -1 : _vm.checkItem
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.checkItem,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkItem = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.checkItem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.checkItem = $$c;
        }
      }
    }
  }), _c('b-link', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-policy",
      modifiers: {
        "modal-policy": true
      }
    }],
    staticClass: "agree__link"
  }, [_vm._v("我已同意活動條款及個人資料聲明")])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "dialog-class": "modal-policy mx-lg-auto",
      "id": "modal-policy",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('h5', {
    staticClass: "modal-title text-center"
  }, [_vm._v(_vm._s(_vm.event.config.T_C_title))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.event.config.T_C_content)
    }
  })])], 1)], 2)]), _vm.checkItem ? _c('button', {
    staticClass: "d-block",
    attrs: {
      "disabled": _vm.isExpired
    },
    on: {
      "click": _vm.redeemCodeAction
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    class: _vm.isExpired && 'grayscale',
    attrs: {
      "src": require("./images/newyear_btn_submit.png")
    }
  })]) : _c('a', {
    staticClass: "d-block"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/newyear_btn_submit_disabled.png")
    }
  })]), _c('b-modal', {
    attrs: {
      "dialog-class": "modal-result text-center mx-lg-auto",
      "id": "modal-result",
      "centered": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_vm.successRedeem.length > 0 ? _c('div', [_c('div', {
          staticClass: "modal-title",
          domProps: {
            "innerHTML": _vm._s(_vm.event.config.redeem_msg_success_title.replace('{$redeem_count}', _vm.successRedeem.length))
          }
        }), _c('div', {
          staticClass: "w-75 modal-result__hr mx-auto my-3"
        }), _vm.failedRedeem.length == 0 && _vm.existingRedeem.length == 0 && _vm.errorMessage.length == 0 ? _c('div', {
          staticClass: "modal-title",
          domProps: {
            "innerHTML": _vm._s(_vm.event.config.redeem_msg_success_content)
          }
        }) : _vm._e()]) : _vm._e(), _vm.failedRedeem.length > 0 ? _c('div', [_c('div', {
          staticClass: "modal-title",
          domProps: {
            "innerHTML": _vm._s(_vm.event.config.redeem_msg_failed.replace('{$redeem_count}', _vm.failedRedeem.length))
          }
        }), _c('div', _vm._l(_vm.failedRedeem, function (f, fdx) {
          return _c('div', {
            key: fdx,
            staticClass: "p-1 text-uppercase"
          }, [_vm._v(_vm._s(f))]);
        }), 0)]) : _vm._e(), _vm.existingRedeem.length > 0 ? _c('div', [_c('div', {
          staticClass: "modal-title",
          domProps: {
            "innerHTML": _vm._s(_vm.event.config.redeem_msg_existing.replace('{$redeem_count}', _vm.existingRedeem.length))
          }
        }), _c('div', _vm._l(_vm.existingRedeem, function (f, fdx) {
          return _c('div', {
            key: fdx,
            staticClass: "p-1 text-uppercase"
          }, [_vm._v(_vm._s(f))]);
        }), 0)]) : _vm._e(), _vm.errorMessage.length > 0 ? _c('div', _vm._l(_vm.errorMessage, function (i, idx) {
          return _c('div', {
            key: idx,
            staticClass: "modal-title"
          }, [_vm._v(" " + _vm._s(i) + " ")]);
        }), 0) : _vm._e(), _c('b-link', {
          staticClass: "d-block mt-3",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('img', {
          staticClass: "img-fluid",
          attrs: {
            "src": require("./images/newyear_btn_confirm.png")
          }
        })])];
      }
    }])
  })], 1), _vm.list.length > 0 ? _c('div', {
    staticClass: "pb-5"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/newyear_title3.png")
    }
  }), _c('div', {
    staticClass: "reel mt-2"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/newyear_reel.png")
    }
  }), _c('table', {
    staticClass: "reel__content table table-borderless"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.list, function (i, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(i.sn))]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.moment(i.date).format("YYYY-MM-DD HH:mm")))])]);
  }), 0), _c('tfoot', [_c('tr', {
    staticClass: "reel__content__footer"
  }, [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("總抽獎次數")]), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.list.length))])])])]), _c('img', {
    staticClass: "img-fluid reel__reverse",
    attrs: {
      "src": require("./images/newyear_reel.png")
    }
  })])]) : _vm._e(), _vm._m(1)])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', {
    staticClass: "reel__content__header"
  }, [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("抽獎序號")]), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("登錄時間")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center p-3 page__footer"
  }, [_c('div', [_vm._v("寶雅國際股份有限公司 版權所有")]), _c('div', [_vm._v("© 2025 Poya international Co., Ltd All Rights Reserved.")])]);
}]

export { render, staticRenderFns }